import axiosInstance from '../utils/axiosConfig';

// Use the shared axiosInstance which normalizes routes and attaches credentials/tokens
const api = axiosInstance;


// Auth Services
export const authService = {
  login: (credentials) => api.post('/auth/login', credentials),
  register: (userData) => api.post('/auth/register', userData),
  getProfile: () => api.get('/auth/profile'),
  updateProfile: (userData) => api.put('/auth/profile', userData),
  changePassword: (passwords) => api.post('/auth/change-password', passwords)
};

// Products Services
export const productService = {
  getAllProducts: (category) => api.get('/products', { params: { category } }),
  getProductById: (id) => api.get(`/products/${id}`),
  getFeaturedProducts: () => api.get('/products/featured'),
  createProduct: (productData) => api.post('/products', productData),
  updateProduct: (id, productData) => api.put(`/products/${id}`, productData),
  deleteProduct: (id) => api.delete(`/products/${id}`),
  getProducts: (params) => api.get('/products', { params }),
  getProductsByCategory: (categoryId) => api.get(`/categories/${categoryId}/products`)
};

// Categories Services
export const categoryService = {
  getAllCategories: () => api.get('/categories'),
  getCategoryById: (id) => api.get(`/categories/${id}`),
  createCategory: (categoryData) => api.post('/categories', categoryData),
  updateCategory: (id, categoryData) => api.put(`/categories/${id}`, categoryData),
  deleteCategory: (id) => api.delete(`/categories/${id}`),
};

// Cart Services
export const cartService = {
  getCartItems: () => api.get('/cart'),
  addToCart: (productId, quantity) => api.post('/cart/add', { productId, quantity }),
  updateCartItem: (itemId, quantity) => api.put(`/cart/${itemId}`, { quantity }),
  removeFromCart: (itemId) => api.delete(`/cart/${itemId}`),
  clearCart: () => api.delete('/cart'),
};

// Order Services
export const orderService = {
  getUserOrders: () => api.get('/orders/user'),
  getOrderById: (id) => api.get(`/orders/user/${id}`),
  createRazorpayOrder: (data) => api.post('/orders/create-razorpay-order', data),
  verifyRazorpayPayment: (data) => api.post('/orders/verify-razorpay-payment', data),
  createOrder: (orderData) => api.post('/orders', orderData),
  getAllOrders: () => api.get('/orders/all'), // Admin only
  updateOrderStatus: (id, status) => api.patch(`/orders/${id}/status`, { status }), // Admin only
  getOrders: (params) => api.get('/orders', { params }), // Supports pagination, sorting, and filtering
  cancelOrder: (id) => api.post(`/orders/${id}/cancel`),
};

// Admin Services
export const adminService = {
  getDashboardStats: () => api.get('/admin/dashboard-stats'),
  getUsers: (params) => api.get('/admin/users', { params }),
  getUserById: (id) => api.get(`/admin/users/${id}`),
  updateUser: (id, userData) => api.patch(`/admin/users/${id}`, userData),
  deleteUser: (id) => api.delete(`/admin/users/${id}`),
  getProductAnalytics: (productId) => api.get(`/admin/analytics/products/${productId}`),
  getOrderAnalytics: (period) => api.get('/admin/analytics/orders', { params: { period } }),
  getRevenueAnalytics: (period) => api.get('/admin/analytics/revenue', { params: { period } }),
  getProducts: (params) => api.get('/admin/products', { params }),
  createProduct: (productData) => api.post('/admin/products', productData),
  updateProduct: (id, productData) => api.patch(`/admin/products/${id}`, productData),
  deleteProduct: (id) => api.delete(`/admin/products/${id}`)
};

export default api; 